function initGallery(root = document) {
  root.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    if (!main || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    gallery.querySelectorAll('[data-gallery-image]').forEach((button) => {
      button.addEventListener('click', () => {
        main.src = button.dataset.galleryImage;
        main.removeAttribute('srcset');
        main.alt = button.querySelector('img').alt;
        gallery.querySelectorAll('[data-gallery-image]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  });
}
initGallery();
document.addEventListener('shopify:section:load', (event) => initGallery(event.target));
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const panel = event.target.closest('[data-purchase-panel]');
  const price = panel.querySelector('[data-variant-price]');
  if (price) price.textContent = option.dataset.price;
});

function updateBuyNow(panel) {
  const link = panel.querySelector('[data-buy-now]');
  const form = panel.querySelector('form');
  if (!link || !form) return;
  const quantity = form.querySelector('[name="quantity"]');
  const variant = form.querySelector('[name="id"]');
  if (!quantity.checkValidity() || !variant.value) return;
  link.href = `${link.dataset.cartBase}/${encodeURIComponent(variant.value)}:${quantity.value}`;
}
document.addEventListener('input', (event) => {
  if (event.target.matches('[data-purchase-quantity]')) updateBuyNow(event.target.closest('[data-purchase-panel]'));
});
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-variant-select]')) updateBuyNow(event.target.closest('[data-purchase-panel]'));
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-buy-now]');
  if (!link) return;
  const form = link.closest('form');
  if (!form.reportValidity()) event.preventDefault();
  else updateBuyNow(link.closest('[data-purchase-panel]'));
});

document.addEventListener('click', (event) => {
  const shortcut = event.target.closest('[data-buy-shortcut]');
  if (!shortcut) return;
  const panel = document.querySelector('[data-purchase-panel]');
  if (!panel) return;
  const buy = panel.querySelector('[data-buy-now]');
  if (buy) { event.preventDefault(); buy.click(); }
});
